export async function fetcher<T>(url: string): Promise<T> {
  const searchParams = new URLSearchParams({ href: url });
  const response = await fetch(`/api/fetcher?${searchParams.toString()}`);
  const responseJson = await response.json();
  if (!response.ok) {
    throw responseJson;
  }
  return responseJson;
}
